import React from "react";
import "./index.css";
import Grid from "@material-ui/core/Grid";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import Typical from "react-typical";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer>
          {/* <nav className="navbar">
              <div className = "max-width">
                  <ul className="menu">
                      <li>
                          <a><GitHubIcon/></a>
                      </li>
                  </ul>

              </div>
          </nav> */}
        <div className="footer-bar">
          <span>Visit My Profiles</span>
          <ul className="icon">
          <li>
            <a href="https://github.com/SakshatMali" target="_blank" className="f-button"><GitHubIcon style={{fontSize:"30px"}}/></a>
          </li>
          <li>
          <a href="https://www.linkedin.com/in/sakshat-mali" target="_blank" className="f-button"><LinkedInIcon style={{fontSize:"30px"}}/></a>
          </li>
          <li>
          <a href="https://twitter.com/SakshatMali?s=08" target="_blank" className="f-button"><TwitterIcon style={{fontSize:"30px"}}/></a>
          </li>
          <li>
          <a href="https://www.instagram.com/sakshat_mali/" target="_blank" className="f-button"><InstagramIcon style={{fontSize:"30px"}}/></a>
          </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Footer;
